module.exports = __webpack_public_path__ + "7f1ac9f51b6cc45e2144d92266227eaa.svg";